import { Flex, Input, Space } from "antd"
import { PickupInfoInterface } from "../../types"
import { GrayLabel } from "../GeneralComponents"


export const PickupInfoInput = (props: {
  pickupInfo: PickupInfoInterface
  setPickupInfo: React.Dispatch<React.SetStateAction<PickupInfoInterface>>
}): JSX.Element => {
  // console.log(props.pickupInfo)
  return (
    <Flex vertical gap="small" style={{marginTop:10}}>
      <Space direction="vertical" size="middle">
        <Input
          addonBefore="Contact Person:"
          type="text"
          id="contact"
          // style={{maxWidth:'30em'}}
          value={props.pickupInfo.contactPerson}
          onChange={(e) => {
            props.setPickupInfo({
              ...props.pickupInfo,
              contactPerson: e.target.value,
            })
          }}
          size="middle"
          // maxLength={60}
          name="contact"
        />
        <Input
          addonBefore="Phone number:"
          type="text"
          id="phone"
          // style={{maxWidth:'30em'}}
          value={props.pickupInfo.phone}
          onChange={(e) => {
            props.setPickupInfo({
              ...props.pickupInfo,
              phone: e.target.value,
            })
          }}
          size="middle"
          // maxLength={60}
          name="phone"
        />
      </Space>
      <div>
        <GrayLabel style={{color:'gray',fontStyle:'italic',marginTop:'5px',marginBottom:'2px'}}>Special instructions for pickup:</GrayLabel>
        <Input
          
          type="text"
          id="instructions"
          value={props.pickupInfo.specialInstructions}
          onChange={(e) => {
            props.setPickupInfo({
              ...props.pickupInfo,
              specialInstructions: e.target.value,
            })
          }}
          size="middle"
          // maxLength={60}
          name="instructions"
        />
      </div>
    </Flex>
  )
}
